'use strict';

const Mn = require('backbone.marionette');
const TaskCollectionRepository = require('my/domain/repository/task-collection');
const TaskListView = require('my/ui/task/list');
const PrimaryContextView = require('balus/ui/view/primary-context');
const Template = require('balus/ui/template/sidepanel/task.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        'taskList': '.task-list-wrapper'
    },
    ui: {
        'closeButton': '.close-sidepanel'
    },
    triggers: {
        'click @ui.closeButton': 'close:sidepanel'
    },

    onRender: function() {
        TaskCollectionRepository.my()
            .fetchFirstPage(10)
            .then(tasks => {
                this.showChildView('taskList', new TaskListView({
                    collection: tasks,
                    context: this.getOption('context'),
                    PrimaryContextView: PrimaryContextView
                }));
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/sidepanel/task.js